exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hideText[data-v-fdde1b5c]{text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;white-space:normal}.clearfix[data-v-fdde1b5c]{*zoom:1}.clearfix[data-v-fdde1b5c]:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}", ""]);

// exports
